import { render, staticRenderFns } from "./TypeMonte.vue?vue&type=template&id=d0d858b0&"
import script from "./TypeMonte.vue?vue&type=script&lang=js&"
export * from "./TypeMonte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports